export const getCustomerName = (customer) => {
    const forename = customer?.forename ?? "";
    const surname = customer?.surname ?? "";
    if(!forename && !surname) return "Unknown";
    if(!forename) return surname;
    if(!surname) return forename;
    return `${forename} ${surname}`;
}